"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const RoundButton = ({ number, roundValue, factor, appTheme, onRoundChange }) => {
    return ((0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: {
            padding: 0,
            borderRadius: 15 * factor,
            width: 30 * factor,
            height: 30 * factor,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: roundValue === number ? `${appTheme.palette.primary.light}` : 'lightgray',
            '&:hover': {
                backgroundColor: roundValue === number ? `${appTheme.palette.primary.light}` : 'rgba(0, 0, 0, 0.08)',
            },
            '&:disabled': {
                backgroundColor: 'lightgray',
            }
        }, onClick: () => {
            // console.log('Round Button Clicked:', number);
            onRoundChange(number);
        }, children: (0, jsx_runtime_1.jsx)(material_1.Stack, { direction: 'row', spacing: 0, sx: { alignItems: 'center', justifyContent: 'flex-start' }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: 'subtitle2', color: roundValue === number ? `${appTheme.palette.secondary.main}` : `${appTheme.palette.primary.main}`, sx: {
                    textAlign: 'center',
                    fontWeight: 500
                }, children: number }) }) }));
};
exports.RoundButton = RoundButton;
